"use strict";

function OnClick_ToggleCheckboxes(Value, InputForm) {
    const form = document.getElementById(InputForm);
    if (form) {
        const checkboxes = form.querySelectorAll("input[type='checkbox']");
        for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = Value;
        }
    }
}

/**
 * @deprecated OnClick_ToggleCheckboxesBarcodes() is deprecated, use ecp-checkbox instead
 */
function OnClick_ToggleCheckboxesBarcodes(Value, InputForm) {
    const form = document.getElementById(InputForm);
    if (form) {
        const checkboxes = form.querySelectorAll("input[type='checkbox']");
        for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = Value;
            // Task 660029: Bar Codes: Select all button does not select all.
            if (checkboxes[i].value) {
                ToggleCheckboxes(checkboxes[i].value);
            }
        }
    }
}

function ToggleCheckboxes(ID) {
    if (ID === "default" || ID === "on") {
        // Skip
    } else if (document.getElementById(`${ID}_checkbox`).checked === true) {
        document.getElementById(`${ID}_textbox`).value = "1";
    } else {
        document.getElementById(`${ID}_textbox`).value = "";
    }
}

/**
 * @deprecated ToggleTextboxes() is deprecated, use ecp-checkbox instead
 */
function ToggleTextboxes(ID) {
    // Task 348479
    const inputTextBox = document.getElementById(`${ID}_textbox`);
    EC_Fmt.InputFmt(inputTextBox, ECP.DataType._Integer, 12, false);

    if (inputTextBox.value !== "") {
        document.getElementById(`${ID}_checkbox`).checked = true;
    } else {
        document.getElementById(`${ID}_checkbox`).checked = false;
    }
}

/**
 * @deprecated OnClick_CheckCheckboxes() is deprecated, use ecp-checkbox instead
 */
function OnClick_CheckCheckboxes(InputForm) {
    let IsChecked = false;
    const InputFormElement = document.getElementById(InputForm);

    if (InputFormElement != null) {
        const InputElements = InputFormElement.querySelectorAll("input[type='checkbox']");
        for (let i = 0; i < InputElements.length; i++) {
            if (InputElements[i].checked) {
                IsChecked = true;
                break;
            }
        }
    }

    if (IsChecked) {
        InputFormElement.submit();
    } else {
        ECP.Dialog.Alert("You must first select at least one record.");
    }

    return IsChecked;
}

/**
 * @deprecated OnClick_CheckRadioButton() is deprecated, use ecp-checkbox instead
 */
function OnClick_CheckRadioButton(InputForm) {
    document.getElementById(InputForm).submit();
}

function OnClick_CheckAll(checkbox) {
    const tableID = checkbox.closest("table").id;
    const InputElements = document.getElementById(tableID).querySelectorAll("input[type='checkbox']");
    for (let i = 0; i < InputElements.length; i++) {
        InputElements[i].checked = checkbox.checked;
    }
}
